export default __webpack_public_path__ + "static/media/pierKlein.d3e0722e.jpg";